













import {Component, Prop, Vue} from 'vue-property-decorator'
import Modal from "@/components/modal/Modal.vue";

@Component({
    components: {Modal}
})
export default class ModalTrigger extends Vue {
    @Prop()
    title!: string;

    @Prop({
        default: true
    })
    closeOnOutsideTap!: boolean;

    open: boolean = false;

    private get portalOrder(): number {
        if (document.getElementById('modal')?.innerHTML !== '') {
            return 2;
        }
        return 1;
    }

    closeModal() {
        this.open = false;
    }

    openModal() {
        this.open = true;
    }
}
